import { Firestore, initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { firebaseConfig, environmentType, deploymentEnvironment, emulatorPorts } from '../config';

/**
 * Connect Firestore emulator on development environment and local deployment
 * @param firestore Firestore instance
 */
export const connectFirestoreEmulatorOnDev = async (firestore: Firestore) => {
  if (environmentType === 'development' && deploymentEnvironment === 'local') {
    try {
      const firestoreResponse = await fetch(`http://localhost:${emulatorPorts.firestore}`);
      if (firestoreResponse.ok) {
        connectFirestoreEmulator(firestore, 'localhost', emulatorPorts.firestore);
        console.log('Connected to Firebase Firestore DB emulator');
      }
    } catch (error) {
      console.log('Firebase Firestore DB emulator is not running');
    }
  }
};

// Initialize Firebase app
export const app = initializeApp(firebaseConfig);

/**
 * Initialize Firestore instance with ignoreUndefinedProperties enabled
 */
export const firestore: Firestore = initializeFirestore(app, {
  ignoreUndefinedProperties: true
});

// Connect to Firestore emulator if in development
connectFirestoreEmulatorOnDev(firestore);